/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline';
import makeStyles from '@mui/styles/makeStyles';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function HtmlRender({ data, htmlProfile }) {
  const classes = useStyles();

  const htmlSafeData = data.replace(/(?:\r\n|\r|\n)/g, '<br />');
  const sanitizedData = () => ({
    __html: DOMPurify.sanitize(htmlSafeData, { USE_PROFILES: { html: htmlProfile } }),
  });

  return (
    <ScopedCssBaseline classes={{ root: classes.scoped }}>
      <span dangerouslySetInnerHTML={sanitizedData()} />
    </ScopedCssBaseline>
  );
}

HtmlRender.propTypes = {
  data: PropTypes.string,
  htmlProfile: PropTypes.bool,
};

HtmlRender.defaultProps = {
  data: '',
  htmlProfile: false,
};

export default React.memo(HtmlRender);
